/**
 * Stock placeholder images (Unsplash). Replace with your own files in /public when ready.
 */
export const SOCCER_LANDING_IMAGES = {
  /** Team celebration / group of players — tournament atmosphere */
  teamBackground:
    'https://images.unsplash.com/photo-1511886929837-354d827aae26?auto=format&fit=crop&w=1920&q=80',
  /** Stadium crowd layer for depth */
  stadiumBackground:
    'https://images.unsplash.com/photo-1529900748604-0752aee0fba8?auto=format&fit=crop&w=1920&q=80',
};
